__webpack_require__.p = "/board-games-bond/";